export default __webpack_public_path__ + "static/media/category-active.3e5b0496.svg";